import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '../../../services/api.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContactAddressService } from '../../../services/contactAddress.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { ErrorManagerService } from 'src/app/services/error-manager.service';
import { MessageTitle, RegExPattern, UserType } from '../../../enums/constants';
import { ContactAddressForm } from '../../../interfaces/ContactAddressForm';

@Component({
    selector: 'app-add',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss'],
    standalone: false
})
export class AddContactAddressComponent implements OnInit {
  model: any;
  editing: boolean;
  saving: boolean;
  addModal: boolean;
  dialogConfig: MatDialogConfig;
  loading: boolean = false;
  user: any;
  vaultUserForAdmin: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AddContactAddressComponent>,
    private apiService: ApiService,
    private contactAddressService: ContactAddressService,
    private matDialog: MatDialog,
    public errorManager: ErrorManagerService,
  ) {
    this.editing = false;
    if (data) {
      if (data.model) {
        this.model = data.model;
      }
      if (data.edit) {
        this.editing = data.edit;
      }
      this.vaultUserForAdmin = data.vaultUserForAdmin;
    }
    this.saving = false;
  }

  form = new FormGroup<ContactAddressForm>({
    address_1: new FormControl('', [
      Validators.required,
      Validators.minLength(2)
    ]),
    address_2: new FormControl('', []),
    city: new FormControl('', [Validators.required, Validators.minLength(2)]),
    state: new FormControl('', [Validators.required]),
    zip: new FormControl('', [
      Validators.pattern(RegExPattern.ZIP_CODE)
    ])
  });

  ngOnInit(): void {
    if (this.model) {
      this.form.patchValue(this.model);
      this.addModal = false;
    } else {
      this.editing = false;
      this.addModal = true;
    }
  }

  checkAndSetClass(e) {
    const type = e.type;
    const target = e.target;
    const value = target.value;
    const parentElement = target.parentElement;

    if (value || type === 'focus') {
      parentElement.classList.add('inputted');
    } else {
      parentElement.classList.remove('inputted');
    }
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  submit() {
    const params = this.form.value;
    const self = this;
    this.form.markAllAsTouched();
    if (self.form.valid) {
      params.label = UserType.CONTACT;
      if (params.state) {
        params.state = params.state.toUpperCase();
      }

      if (!self.model) {
        self.loading = true;
        self.contactAddressService.addAddress(params, this.vaultUserForAdmin?.id, {
          getResult(response) {
            self.loading = false;
            self.errorManager.showSuccess(self.errorManager.ERRORS.add_success, MessageTitle.SUCCESS);
            self.dialogRef.close({ add: true, data: response });
          },
          getError(err) {
            self.loading = false;
            self.errorManager.showError(self.errorManager.getMessage(err.error), MessageTitle.ERROR);
          },
        });
      } else {
        params.addressId = self.model.addressId;
        self.loading = true;
        self.contactAddressService.editAddress(params, this.vaultUserForAdmin?.id, {
          getResult(_response) {
            self.loading = false;
            self.errorManager.showSuccess(self.errorManager.ERRORS.details_update_success, MessageTitle.SUCCESS);
            self.saving = false;
            self.editing = false;
            self.dialogRef.close({ edit: true, data: params });
          },
          getError(err) {
            self.loading = false;
            self.saving = false;
            self.errorManager.showError(self.errorManager.getMessage(err.error), MessageTitle.ERROR);
          },
        });
      }
    }
  }
  edit() {
    this.editing = true;
  }

  destroy() {
    var self = this;
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.data = {
      title: 'Are you sure?',
      message: 'You are about to delete this address ',
    };

    let dialogRef = this.matDialog.open(
      ConfirmDialogComponent,
      {
        disableClose: true,
        data: {
          title: 'Are you sure?',
          message: 'You are about to delete this address ',
        }
      }
    );

    // listen to response
    dialogRef.afterClosed().subscribe((destroy) => {
      if (destroy) {
        self.loading = true;
        var params = {
          addressId: self.model.addressId,
        };
        this.contactAddressService.deleteAddress(params, {
          getResult(_response) {
            self.loading = false;
            self.errorManager.showSuccess(self.errorManager.ERRORS.delete_success, MessageTitle.SUCCESS);
            self.dialogRef.close({ delete: true, data: params });
          },
          getError(err) {
            self.loading = false;
            console.log(err);
            self.errorManager.showError(self.errorManager.getMessage(err.error), MessageTitle.ERROR);
          },
        });
      }
    });
  }
}
